import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesReturns } from "../../constants";
import { ReturnDetails } from "../../returns.types";

export const requestGetReturnDetails = async (
  id: string
): Promise<ReturnDetails> => {
  return await instance.get(buildUrl(ApiRoutesReturns.ReturnDetails, id));
};
